/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Florian Hartl <f.hartl@techdivision.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';

/**
 * ContractFootnotes Component
 * @param text
 * @param sx
 * @returns {JSX.Element}
 * @constructor
 */
export function ContractFootnotes({ text, sx }) {
  const { t } = useTranslation();
  return (
    <Box sx={sx}>
      <Accordion data-block-event>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 0 }}>
          {t('footnotes')}
        </AccordionSummary>
        <AccordionDetails
          sx={{
            p: 0,
            mb: 1,
          }}
        >
          {text}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

ContractFootnotes.propTypes = {
  text: PropTypes.element.isRequired,
  sx: PropTypes.object,
};

ContractFootnotes.defaultProps = {
  sx: {},
};
